import { Grid } from '@mui/material';
import { SVPhoneInput, SVTextInput } from '../core';
import { FORM_FIELDS } from '@/constants/formFields';

export default function ProfileEditSharedInputs() {
  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput name="firstName" {...FORM_FIELDS.FIRST_NAME} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput name="lastName" {...FORM_FIELDS.LAST_NAME} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput disabled name="email" {...FORM_FIELDS.EMAIL} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput disabled name="company" label="Company" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput disabled name="role" label="Role" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVTextInput name="title" label="Title" rules={{ required: true }} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVPhoneInput disabled name="phone" {...FORM_FIELDS.PHONE} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SVPhoneInput name="businessPhone" {...FORM_FIELDS.BUSINESS_PHONE} />
      </Grid>
    </>
  );
}
